// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"166":"ff87e0a4","300":"d7542f34"}[chunkId] + ".chunk.css";
};